'use client';

import type { ComponentProps } from 'react';
import { useEffect, useState } from 'react';
import { Link } from '@/i18n/routing';
import openModal from '@/modals/utils/openModal';
import { useAppSelector } from '@/redux/hooks';

interface PrivateLinksProps extends ComponentProps<typeof Link> {
  href: string;
  children: React.ReactNode;
  className?: string;
  onClick?: (e: React.MouseEvent<HTMLAnchorElement>) => void;
}

export const PrivateLinks = ({
  href,
  children,
  className,
  onClick,
  ...props
}: PrivateLinksProps) => {
  const { userSession } = useAppSelector(state => state.user);
  const [isHydrated, setIsHydrated] = useState(false);

  useEffect(() => {
    setIsHydrated(true);
  }, []);

  const handleGuestClick = () => {
    openModal('login');
  };

  if (!isHydrated || !userSession) {
    return (
      <button
        type="button"
        onClick={handleGuestClick}
        aria-label={props['aria-label']}
        className={className}
      >
        {children}
      </button>
    );
  }

  return (
    <Link
      href={href}
      onClick={onClick}
      className={className}
      {...props}
    >
      {children}
    </Link>
  );
};
